var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19651 4.21174L8.00012 3.40813C8.32824 3.08001 8.49231 2.91595 8.64962 2.79818C9.6257 2.0675 10.9666 2.0675 11.9427 2.79818C12.1 2.91595 12.264 3.08001 12.5922 3.40813C12.9203 3.73625 13.0843 3.90031 13.2021 4.05763C13.9328 5.03371 13.9328 6.37459 13.2021 7.35067C13.0843 7.50798 12.9203 7.67204 12.5922 8.00017L11.7885 8.80378M4.20134 7.20692L3.40808 8.00017C3.07996 8.32829 2.9159 8.49235 2.79814 8.64966C2.06745 9.62575 2.06745 10.9666 2.79814 11.9427C2.9159 12.1 3.07996 12.2641 3.40808 12.5922C3.73621 12.9203 3.90027 13.0844 4.05758 13.2022C5.03366 13.9328 6.37454 13.9328 7.35063 13.2022C7.50794 13.0844 7.672 12.9203 8.00012 12.5922L8.79337 11.799M6.09613 9.90416L9.9404 6.05989",
    stroke: "#020817",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.f5bfd2c9978f3a135b9ae9a15b15bf0b.svg";
export { ForwardRef as ReactComponent };